import { Shield, Check } from "lucide-react";

export const PricingHero = () => {
  return (
    <section className="relative overflow-hidden py-16 px-4 md:py-20">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-purple-500/5" />
      
      <div className="container mx-auto max-w-5xl relative z-10">
        <div className="text-center space-y-6">
          {/* Headline */}
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold">
            Powerful Modules, Flexible Pricing
          </h1>
          
          {/* Subheadline */}
          <p className="text-xl md:text-2xl text-muted-foreground">
            All the Tools You Need, in One Platform
          </p>

          {/* Trust indicators */}
          <div className="flex flex-wrap justify-center gap-6 text-sm md:text-base text-muted-foreground pt-2">
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-primary" />
              <span>14-day free trial</span>
            </div>
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-primary" />
              <span>No credit card needed</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
